import { State, Mutation } from 'vuex-simple';

export class SettingsState {
  public cmsActive = false;
}

export class SettingsStore {
  @State()
  public state = new SettingsState();

  @Mutation()
  public setCmsActive(value: boolean): void {
    this.state.cmsActive = value;
  }
}
